class CareerOffices {
  constructor(el, config) {
    this.el = el;
    this.$el = $(el);    
    this._officesApiURL = window.ddb.api.offices.apiUrl;
    this._is_country_specific = window.ddb.api.offices.is_country_specific;
    this._selected_offices = window.ddb.api.offices.selected_offices;
    
    this._selectedRegion = null;
    this._selectedCountry = null;
    this._defaultRegion = window.ddb.api.offices.region || null;
    this._defaultCountry = window.ddb.api.offices.country|| null;

    this._regions = [];
    this._countries = [];
    this._offices = [];

    this.$regions = this.$el.find('.js-region-list');
    this.$countries = this.$el.find('.js-country-list');
    this.$resultPanel = this.$el.find('.js-result-panel');
    this.$resultList = this.$el.find('.js-result-list')
    this.$careerPanel = null;

    this._isLoading = false;

    window.addEventListener('popstate', CareerOffices.prototype.onPopState.bind(this));
    this.onPopState();

    $.fn.matchHeight._afterUpdate = function(event, groups) {
      window.ddb.utils.triggerResize()
    };
  }

  layout() {
    const container = this.$resultList.data('ddb.cardcontainer');

    if (container) {
      container.layout();
    }
  }

  pushState() {
    let uris = [];

    if (this._selectedRegion) uris.push(this._selectedRegion);
    if (this._selectedCountry) uris.push(this._selectedCountry);

    window.history.pushState(
      null,
      '',
      window.location.origin + '/careers/' + uris.join('/')
    );
  }

  async onPopState(e) {
    // populate regions
    if (this._regions.length == 0) {
      await this._populateRegions();
    }
    
    // only react to /careers/location URI
    if (window.location.pathname.indexOf('/careers') != 0) return;
    
    if (this._is_country_specific == true) {       
      await this._setRegion(null, this._defaultRegion);                       
      await this._setCountry(null, this._defaultCountry);      
    } else {      
      this.$regions.css({ display: 'block' });
      // get state
      const uriParams = window.location.pathname.substring('/careers'.length).split('/');
      const region = (uriParams[1] && uriParams[1] != '') ? uriParams[1] : null;
      const country = (uriParams[2] && uriParams[2] != '') ? uriParams[2] : null;
    
      if (region != this._selectedRegion) {        
        await this._setRegion(null, region);

        this.$regions.find('.btn-filter').text(
          this._getLabelFromList(this._regions, region)
            || this.$regions.find('.btn-filter').data('placeholder')
        );
      }

      if (country != this._selectedCountry) {
        await this._setCountry(null, country);

        this.$countries.find('.btn-filter').text(
          this._getLabelFromList(this._countries, country)
            || this.$countries.find('.btn-filter').data('placeholder')
        );
      }
    }
    window.ddb.utils.triggerResize();
  }

  async _onRegionChange(e) {
    const region = $(e.target).data('value');

    this.$regions.find('.btn-filter').text(e.target.innerText);
    this._setRegion(e, region);
  }

  async _onCountryChange(e) {
    const country = $(e.target).data('value');

    this.$countries.find('.btn-filter').text(e.target.innerText);
    this._setCountry(e, country);
  }

  async _onLocationClick(e) {
    e.preventDefault();
    const office = $(e.target).data('office');

    this._setLocation(e, office);
  }

  async _fetchRegions() {
    const response = await axios.get(this._officesApiURL);
    return response.data
  }

  async _fetchCountries(region) {
    const response = await axios.get(
      `${this._officesApiURL}${region}`
    );
    return response.data
  }

  async _fetchOffices(region, country) {
    const response = await axios.get(
      `${this._officesApiURL}${region}/${country}`
    );
    return response.data;
  }

  async _populateRegions() {  
    try {
      const regions = await this._fetchRegions();
      this._regions = this._processRegionList(regions);

      this._populateDropdown(
        this.$regions,
        this._regions,
        'Region',
        this._selectedRegion,
        CareerOffices.prototype._onRegionChange.bind(this)
      );

      window.ddb.utils.triggerResize();
    } catch (e) {
      // @TODO: error
      console.log('error', e);
    }
  }

  async _populateCountries() {
    try {
      const selectedRegion = this._selectedRegion;
      const countries = await this._fetchCountries(selectedRegion);

      // the state already changed. cancel process
      if (selectedRegion != this._selectedRegion) return;

      this._countries = this._processCountryList(countries, selectedRegion);

      this._populateDropdown(
        this.$countries,
        this._countries,
        'Country',
        this._selectedCountry,
        CareerOffices.prototype._onCountryChange.bind(this)
      );

      window.ddb.utils.triggerResize();
    } catch (e) {
      // @TODO: error
      console.log('error', e);
    }
  }

  async _populateOffices() {
    const selectedRegion = this._selectedRegion;
    const selectedCountry = this._selectedCountry;

    try {      
      this._showOfficesLoading();

      const offices = await this._fetchOffices(selectedRegion, selectedCountry);

      // the state already changed. cancel process
      if (selectedRegion != this._selectedRegion || selectedCountry != this._selectedCountry) return;

      // Only show offices that have a careers link, a careers email or a jobframe_link
      this._offices = this._processOfficesList(offices, selectedRegion, selectedCountry);

      this._hideOfficesLoading();

      this._renderOfficesList();

      window.ddb.utils.triggerResize();
    } catch (e) {
      // @TODO: error
      console.log('error', e);
    }
  }

  async _populateCareersFrame( office ) {
    try {
      this._showCareerLoading();
      this.$resultPanel.css({ display: '' });
      const jobframe_link = office.jobs.jobframe_link;
      this._hideCareerLoading();
      if ( jobframe_link ) {
        this.$careerPanel.find('.career-offices-frame').attr('src', jobframe_link);
      } else {
        this.$careerPanel.find('.card-panel__body').html('<span class="">No Job Openings</span>');
      }

      window.ddb.utils.triggerResize();
    } catch (e) {
      // @TODO: error
      console.log('e', e);
    }
  }

  async _setRegion(e, region) {
    this._populateDropdown(this.$countries, [], 'Loading...');

    this._selectedRegion = region;
    this._selectedCountry = null;
    this._selectedOffice = null;

    if (e) this.pushState();

    this._countries = [];
    this._offices = [];

    if (region) {
      if (this._is_country_specific == true) {               
        this.$countries.css({ display: 'none' }); 
      } else {
        this.$countries.css({ display: '' });
      }      
    } else {
      this.$countries.css({ display: 'none' });
    }

    this.$resultPanel.css({ display: 'none' });

    window.ddb.utils.triggerResize();

    if (region) await this._populateCountries();
  }

  async _setCountry(e, country) {
    this._selectedCountry = country;
    this._selectedOffice = null;

    if (e) this.pushState();

    this._offices = [];

    if (country) {
      this.$resultPanel.css({ display: '' });
    } else {
      this.$resultPanel.css({ display: 'none' });
    }

    const container = this.$resultList.data('ddb.cardcontainer');
    container.empty();

    if (this.$careerPanel) {
      this.$careerPanel.modal('hide');
    }

    window.ddb.utils.triggerResize();

    if (country) await this._populateOffices();
  }

  async _setLocation(e, office) {
    this._selectedOffice = office;

    // find the index of this office
    this._attachCareerPanel(office, this._getOfficeIndex(office.slug));

    this._populateCareersFrame( office );
  }

  _processRegionList(res) {
    return res.map((region) => {
      return { value: region.slug, label: region.name };
    });
  }

  _processCountryList(res, region) {
    const regions = res.filter(entry => entry.slug == region);

    if (regions.length == 0) return [];

    return regions[0].countries.map((country) => {
      return { value: country.slug, label: country.name }
    });
  }

  _processOfficesList(res, region, country) {
    const regions = res.filter(entry => entry.slug == region);

    if (regions.length == 0) return [];

    const countries = regions[0].countries.filter(entry => entry.slug == country);

    if (countries.length == 0 || !countries[0].offices) return [];

    const offices = countries[0].offices;

    return offices.filter((office) => {
      return ( office.lists.includes('J') )
    });


  }

  _showOfficesLoading() {
    this.$resultPanel.find('.result-panel__loading').css({ display: '' });
  }

  _hideOfficesLoading() {
    this.$resultPanel.find('.result-panel__loading').css({ display: 'none' });
  }

  _showOffice(resultList, template, office, container) {  
    const $template = $(template);

    $template
      .find('[data-modal]')
        .data('office', office)
        .on('click', CareerOffices.prototype._onLocationClick.bind(this));
      
    resultList.cardcontainer();

    container.add($template);      
    resultList.find('.card-container__item').matchHeight({ byRow: false }); 
  }

  _renderOfficesList() {
    const container = this.$resultList.data('ddb.cardcontainer');
    container.empty();     
    const resultList = this.$resultList; 

    this._offices.forEach((office) => {
      const template = this._generateOfficeCard(office);      

      if( this._selected_offices.length > 0) {
        if (this._selected_offices.includes(office.slug) == true) {
          this._showOffice(resultList, template, office, container);                      
        }        
      } else {
        this._showOffice(resultList, template, office, container);        
      }
    });
    container.layout();

    window.ddb.$document.trigger('sitescroll.rebuild');
  }

  _generateOfficeCard(office) {
    let footerHtml = '';

    if (office.jobs.jobframe_link && office.jobs.jobframe_link.trim()) {
      const link = (office.jobs.jobframe_link.indexOf('http') == -1) ? `http://${office.jobs.jobframe_link}` : office.jobs.jobframe_link;

      footerHtml += `
        <a href="${link}" target="_blank" data-modal="true" class="link-redirection is-block">View Job Portal</a>
      `
    }

    if (office.jobs.resume_email && office.jobs.resume_email.trim()) {
      footerHtml += `
        <a href="mailto:${office.jobs.resume_email}" class="link-redirection is-block">Contact our Talent Team</a>
      `
    }

    if (office.jobs.resume_link && office.jobs.resume_link.trim()) {
      const link = (office.jobs.resume_link.indexOf('http') == -1) ? `http://${office.jobs.resume_link}` : office.jobs.resume_link;

      footerHtml += `
        <a href="${link}" target="_blank" class="link-redirection is-block">Visit our Job Site</a>
      `
    }

    const tel = (office.details[0].main_phone) ? `<div class="address__tel">Tel. <span>${office.details[0].main_phone}</span></div>` : '';
    const fax = (office.details[0].main_fax) ? `<div class="address__fax">Fax. <span>${office.details[0].main_fax}</span></div>` : '';

    return `
      <li class='card-container__item' data-mh="office-card">
        <div class='card card--office' data-slug='${office.slug}'>
          <figure class='card__image image is-square' style='background-color: #F2F2F2;'  role="none">
            <div style='background-image: url(${office.thumbnail || ""})' alt='${office.city}' class='image-cover'></div>
          </figure>
          <div class='card__content'>
            <address>
              <div class="address__block">
                <div class="address__title">${office.name}</div>
                <div class="address__addr">${office.details[0].address}</div>
              </div>
              <div class="address__block">
                ${tel}
                ${fax}
              </div>
            </address>
          </div>
          <footer class="card__footer card__footer--links">
            ${footerHtml}
          </footer>
        </div>
      </li>
    `;
  }

  //Current approach to the career panel (modal + iframe)
  _attachCareerPanel(office, idx) {
    if (this.$careerPanel == null) {
      let panelTemplate = this._generateCareerPanel();
      this.$careerPanel = $(panelTemplate);
      this.$careerPanel
        .appendTo(document.body)
        .on('hide.ddb.modal', CareerOffices.prototype._removeCareerPanel.bind(this))
        .on('hidden.ddb.modal', CareerOffices.prototype._resetCareerPanel.bind(this));
    }
    
    let careerPanelTitle = office.jobs.jobframe_title ? office.jobs.jobframe_title : office.name;
    let careerPanelSubtitle = office.jobs.jobframe_title ? office.name : office.city;

    this.$careerPanel.find('.modal-title').html(careerPanelTitle);
    this.$careerPanel.find('.modal-subtitle').html(careerPanelSubtitle);

    this.$careerPanel.modal('show');
  }

  _removeCareerPanel() {

    this._selectedOffice = null;

    this.$careerFrame = this.$careerPanel.find('.career-offices-frame');
    this.$careerFrame.src = '';

  }

  _resetCareerPanel() {
    // this.$careerPanel.find('.modal-title').html('');
    // this.$careerPanel.find('.modal-subtitle').html('');
    // this.$careerPanel.find('.spinner').css({ display: 'none' });
  }

  _generateCareerPanel() {
    return `
    <div class="modal fade" id="career-offices-panel" tabindex="-1" role="dialog" aria-labelledby="career-offices-panel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-header__inner">
              <h5 class="modal-title">Mango Communications</h5>
              <div class="modal-subtitle">Sydney</div>
            </div>

            <button type="button" class="button-icon" data-dismiss="modal" aria-label="Close">
              <span class="icon-times-light"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="spinner"></div>
            <iframe class="career-offices-frame" src=''></frame>
          </div>
        </div>
      </div>
    </div>
    `
  }

  _showCareerLoading() {
    this.$careerPanel.find('.spinner').css({ display: '' });
  }

  _hideCareerLoading() {
    this.$careerPanel.find('.spinner').css({ display: 'none' });
  }

  _populateDropdown($el, options, defaultValue, value, callback) {    
    let selectedFound = false;

    // reset
    $el.find('.scroll-content').empty();

    // re-populate
    options.forEach((item, idx) => {
      let html = ` <div class="option ${(value == item.value) ? 'is-selected' : ''}" data-value="${item.value}" data-cursor="disabled">${item.label}</div>`;
      $el.find('.scroll-content').append(html);

      selectedFound = (value == item.value) ? true : selectedFound;
    });

    if (selectedFound) {
      $el.find('.btn-filter').text(value);
    } else {
      $el.find('.btn-filter').text(defaultValue);
    }

    $el.find('.option').on('click', callback);
  }

  _getLabelFromList(list, value) {
    if (list instanceof Array !== true) return null;

    const option = list.filter(opt => opt.value == value);
    return (option && option[0] && option[0].label) ? option[0].label : null;
  }

  _getOfficeIndex(slug) {
    return this._offices.findIndex(element => element.slug == slug);
  }

}

module.exports = CareerOffices;
